"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysInMonth = exports.isLeapYear = exports.weeksDifference = exports.shiftLastWeek = exports.shiftNextWeek = exports.shiftLastMonth = exports.shiftNextMonth = exports.shiftPeriod = exports.shiftDays = exports.weekStartIndex = exports.weekRange = exports.quarterStartDate = exports.quarterEndDate = exports.quarterRange = exports.yearStart = exports.yearEnd = exports.yearRange = exports.monthRange = exports.monthRangeFromShortMonth = exports.insideRange = exports.isValidNumber = exports.areEquivalentNumbers = exports.fromShortString = exports.toShortString = exports.validShortDate = exports.WeekDays = void 0;
const Reports_1 = require("./Reports");
const Errors_1 = require("./Errors");
const SHORT_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const MILLI_SECONDS_IN_MINUTE = 60 * 1000;
const MILLI_SECONDS_IN_DAY = 24 * 60 * MILLI_SECONDS_IN_MINUTE;
exports.WeekDays = {
    Sunday: "Su",
    Monday: "Mo",
    Tuesday: "Tu",
    Wednesday: "We",
    Thursday: "Th",
    Friday: "Fr",
    Saturday: "Sa",
};
// This regex should only match years from 1900 to 2099, Months 01 to 12 and days, 01 to 31
const SHORT_DATE_REGEX = new RegExp(/^((19|20)[0-9]{2}-(10|11|12|0[1-9])-(30|31|10|20|[0-2][1-9]))/);
const SHORT_DATE_REGEX_MDY = new RegExp(/^((10|11|12|0?[1-9])[-/](30|31|10|20|[0-2]?[1-9])[-/]((19|20)[0-9]{2}))/);
function validShortDate(str, reverse = false) {
    return reverse ? SHORT_DATE_REGEX_MDY.test(str) : SHORT_DATE_REGEX.test(str);
}
exports.validShortDate = validShortDate;
function toShortString(date) {
    if (date === null) {
        return '';
    }
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}
exports.toShortString = toShortString;
function fromShortString(dateStr) {
    const year = Number(dateStr.substring(0, 4));
    const month = Number(dateStr.substring(5, 7)) - 1;
    const day = Number(dateStr.substring(8, 10));
    return new Date(year, month, day);
}
exports.fromShortString = fromShortString;
function areEquivalentNumbers(a, b, numDecimals = 2) {
    if (!Number.isFinite(a) || !Number.isFinite(b)) {
        return false;
    }
    const aRounded = a.toFixed(numDecimals);
    const bRounded = b.toFixed(numDecimals);
    return aRounded === bRounded;
}
exports.areEquivalentNumbers = areEquivalentNumbers;
function isValidNumber(value) {
    return Number.isFinite(value) && !Number.isNaN(value);
}
exports.isValidNumber = isValidNumber;
function insideRange(date, startDate, endDate) {
    return !!date?.start && startsAfter(date, startDate) && endsBefore(date, endDate);
}
exports.insideRange = insideRange;
function startsAfter(date, startDate) {
    if (!startDate) {
        return true;
    }
    return startDate <= date.start;
}
function endsBefore(date, endDate) {
    if (!endDate) {
        return true;
    }
    return endDate >= date.end;
}
function monthRangeFromShortMonth(month, year) {
    const mon = SHORT_MONTHS.indexOf(month);
    // If months are out of range, return an empty object
    if (mon < 0 || mon >= SHORT_MONTHS.length) {
        return new Reports_1.ReportStartEndDates(new Date(), "", new Date(), "");
    }
    return monthRangeInternal(mon, year);
}
exports.monthRangeFromShortMonth = monthRangeFromShortMonth;
function monthRange(d) {
    if (!isValid(d)) {
        return new Reports_1.StartEndDates();
    }
    return monthRangeInternal(d.getMonth(), d.getFullYear());
}
exports.monthRange = monthRange;
function yearRange(d) {
    if (!isValid(d)) {
        return new Reports_1.StartEndDates();
    }
    const ret = new Reports_1.StartEndDates();
    ret.start = yearStart(d);
    ret.end = yearEnd(d);
    return ret;
}
exports.yearRange = yearRange;
function yearEnd(startDate) {
    return `${startDate.getFullYear()}-12-31`;
}
exports.yearEnd = yearEnd;
function yearStart(d) {
    return `${d.getFullYear()}-01-01`;
}
exports.yearStart = yearStart;
function isValid(d) {
    return d && !isNaN(d.getTime());
}
function quarterRange(date) {
    const startDate = quarterStartDate(date);
    const endDate = quarterEndDate(date);
    return new Reports_1.ReportStartEndDates(startDate, toShortString(startDate), endDate, toShortString(endDate));
}
exports.quarterRange = quarterRange;
function quarterEndDate(date) {
    return new Date(date.getFullYear(), 3 * Math.floor(date.getMonth() / 3) + 3, 0);
}
exports.quarterEndDate = quarterEndDate;
function quarterStartDate(date) {
    return new Date(date.getFullYear(), 3 * Math.floor(date.getMonth() / 3), 1);
}
exports.quarterStartDate = quarterStartDate;
function weekRange(date, weekStart, period = 1) {
    const weekStartNum = weekStartIndex(weekStart);
    const dayNum = date.getDay();
    let startDate = date;
    if (dayNum !== weekStartNum) {
        // Not at the correct day of the week, need to find out how many days to go back and use that
        // date as the start date
        const daysBack = dayNum > weekStartNum ? dayNum - weekStartNum : 7 - (weekStartNum - dayNum);
        startDate = shiftDays(date, -daysBack);
    }
    const numDays = (period - 1) * 7 + 6;
    const endDate = shiftDays(startDate, numDays);
    return new Reports_1.ReportStartEndDates(startDate, toShortString(startDate), endDate, toShortString(endDate));
}
exports.weekRange = weekRange;
function weekStartIndex(weekStartDayStr) {
    let weekStart = 1;
    if (weekStartDayStr === exports.WeekDays.Sunday) {
        weekStart = 0;
    }
    else if (weekStartDayStr === exports.WeekDays.Tuesday) {
        weekStart = 2;
    }
    else if (weekStartDayStr === exports.WeekDays.Wednesday) {
        weekStart = 3;
    }
    else if (weekStartDayStr === exports.WeekDays.Thursday) {
        weekStart = 4;
    }
    else if (weekStartDayStr === exports.WeekDays.Friday) {
        weekStart = 5;
    }
    else if (weekStartDayStr === exports.WeekDays.Saturday) {
        weekStart = 6;
    }
    return weekStart;
}
exports.weekStartIndex = weekStartIndex;
function shiftDays(date, shift) {
    const shiftedDate = new Date(date.getTime() + shift * MILLI_SECONDS_IN_DAY);
    // For timezones which use daylight savings time, shifting by a full day might be too much or too little
    // We check the difference between offsets and if they aren't the same, we shift again to compensate
    const offsetMin = shiftedDate.getTimezoneOffset() - date.getTimezoneOffset();
    if (offsetMin === 0) {
        return shiftedDate;
    }
    const offsetMs = offsetMin * MILLI_SECONDS_IN_MINUTE;
    return new Date(shiftedDate.getTime() + offsetMs);
}
exports.shiftDays = shiftDays;
function shiftPeriod(d, timeframe, numPeriods) {
    if (timeframe === Reports_1.ReportTimeframes.Month) {
        return numPeriods > 0 ? shiftNextMonth(d, numPeriods) : shiftLastMonth(d, -numPeriods);
    }
    else if (timeframe === Reports_1.ReportTimeframes.Week) {
        return numPeriods > 0 ? shiftNextWeek(d, numPeriods) : shiftLastWeek(d, -numPeriods);
    }
    else if (timeframe === Reports_1.ReportTimeframes.Quarter) {
        return numPeriods > 0 ? shiftNextMonth(d, numPeriods * 3) : shiftLastMonth(d, -numPeriods * 3);
    }
    else if (timeframe === Reports_1.ReportTimeframes.Year) {
        return numPeriods > 0 ? shiftNextMonth(d, numPeriods * 12) : shiftLastMonth(d, -numPeriods * 12);
    }
    else {
        throw Errors_1.CommonErrors.unsupportedTimeframe(shiftPeriod.name, timeframe);
    }
}
exports.shiftPeriod = shiftPeriod;
function shiftNextMonth(date, monthsForward, sameDay = false) {
    if (!date) {
        return date;
    }
    const forward = Math.abs(monthsForward);
    const yearsForward = Math.floor(forward / 12);
    const extraMonths = forward % 12;
    let month = date.getMonth() + extraMonths;
    let year = date.getFullYear() + yearsForward;
    if (month > 11) {
        month = month - 12;
        year = year + 1;
    }
    return new Date(year, month, 
    // If the new month has fewer days than the old month
    // Any dates after will simply use the last day of the new month
    sameDay ? Math.min(date.getDate(), daysInMonth(month, year)) : 1);
}
exports.shiftNextMonth = shiftNextMonth;
function shiftLastMonth(date, monthsBack, sameDay) {
    if (!date) {
        return date;
    }
    const backward = Math.abs(monthsBack);
    const yearsBack = Math.floor(backward / 12);
    const leftoverMonths = backward % 12;
    let month = date.getMonth() - leftoverMonths;
    let year = date.getFullYear() - yearsBack;
    if (month < 0) {
        month = month + 12;
        year = year - 1;
    }
    const day = sameDay ? Math.min(date.getDate(), daysInMonth(month, year)) : 1;
    return new Date(year, month, day);
}
exports.shiftLastMonth = shiftLastMonth;
function shiftNextWeek(date, numWeeks) {
    if (!date) {
        return date;
    }
    return shiftDays(date, 7 * numWeeks);
}
exports.shiftNextWeek = shiftNextWeek;
function shiftLastWeek(date, numWeeks) {
    if (!date) {
        return date;
    }
    return shiftDays(date, -7 * numWeeks);
}
exports.shiftLastWeek = shiftLastWeek;
function weeksDifference(date, compareDate) {
    // For timezones which use daylight savings time
    // We check the difference between offsets and shift by that amount to compensate
    const offsetMs = (date.getTimezoneOffset() - compareDate.getTimezoneOffset()) * MILLI_SECONDS_IN_MINUTE;
    const diff = date.getTime() - compareDate.getTime() - offsetMs;
    return Math.floor(Math.abs(diff) / (7 * MILLI_SECONDS_IN_DAY));
}
exports.weeksDifference = weeksDifference;
function monthRangeInternal(mon, year) {
    const startDate = new Date(year, mon, 1);
    const endDate = new Date(year, mon, daysInMonth(mon, year));
    return new Reports_1.ReportStartEndDates(startDate, toShortString(startDate), endDate, toShortString(endDate));
}
// https://stackoverflow.com/questions/16353211/check-if-year-is-leap-year-in-javascript
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
exports.isLeapYear = isLeapYear;
function daysInMonth(month, year) {
    // 0 based months here (0 = Jan, 1 = Feb, etc)
    if (month === 1 && year && isLeapYear(year)) {
        return 29; // Special case for Feb leap year
    }
    return MONTH_DAYS[month] ?? 30;
}
exports.daysInMonth = daysInMonth;
//# sourceMappingURL=commonUtil.js.map